import React from "react";
import styled from "styled-components";
import { portalColors } from "./BusinessPortalComponents";

const Header = styled.div`
    display: flex;
    flex-direction: ${p => p.flexDirection || "row"};
    justify-content: ${p => p.justifyContent || "flex-start"};
    align-items: ${p => p.alignItems || "center"};
    gap: ${p => p.gap || "1rem"};
    width: ${p => p.width || "100%"};
    max-width: ${p => p.maxWidth};
    margin-top: ${p => p.marginTop || "1rem"};
    margin-bottom: ${p => p.marginBottom};
    padding: 0.9rem 1rem;
    box-sizing: border-box;
    background: ${portalColors.surface};
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    box-shadow: ${portalColors.shadow};
    color: ${portalColors.text};

    @media (max-width: 1440px) {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    }

    @media (max-width: 900px) {
        align-items: stretch;
        flex-direction: column;
    }
`;

function HeaderBox(props) {
    const { children, ...styledProps } = props;
    return (
        <Header {...styledProps}>
            {children}
        </Header>
    );
}

export default HeaderBox;
